import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Select,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import useFieldsData from "layouts/events/create/components/EventForm/data/useFieldsData";
import MDDatePicker from "components/MDDatePicker";
import { useTranslation } from "react-i18next";

function UpdateForm({ updateEvent, setUpdateEvent, onSubmit, onCancel }) {
  const { t } = useTranslation();
  const { fields, loading, error } = useFieldsData(); // Fetch options for type, category, subcategory

  useEffect(() => {
    if (updateEvent) {
      setUpdateEvent(updateEvent);
    }
  }, [updateEvent]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUpdateEvent((prev) => ({ ...prev, [name]: value }));
  };

  const handleDateChange = (date, field) => {
    setUpdateEvent((prev) => ({
      ...prev,
      [field]: date && date[0] ? date[0].toISOString() : null, // Stores as ISO string
    }));
  };

  if (loading) return <MDTypography variant="h6">{t("events.show.updateForm.loading")}</MDTypography>;

  console.log("updateEvent", updateEvent);

  return (
    <MDBox bgColor="dark">
      <MDTypography variant="h6" color="secondary">
        {updateEvent.category.name}
      </MDTypography>
      <Divider sx={{ my: 2 }} />

      {/* Start Date */}
      <Grid item xs={12} sm={12}>
        <MDTypography
          component="label"
          variant="button"
          fontWeight="regular"
          color="text"
          sx={{ display: "block", width: "100%" }} // Ensures full width
        >
          {t("events.show.filterModal.startLabel")}
        </MDTypography>
        <MDDatePicker
          input={{ placeholder: t("events.show.filterModal.placeholderDatetime") }}
          value={
            updateEvent.valid_from ? new Date(updateEvent.valid_from) : null
          } // Ensures it's either a Date object or null
          options={{
            enableTime: true,
            dateFormat: "d/m/Y H:i",
            altFormat: "d/m/Y H:i",
            time_24hr: true,
          }}
          onChange={(date) => handleDateChange(date, "valid_from")}
        />
      </Grid>

      {/* End Date */}
      <Grid item xs={12} sm={12}>
        <MDTypography
          component="label"
          variant="button"
          fontWeight="regular"
          color="text"
          sx={{ display: "block", width: "100%" }} // Ensures full width
        >
          {t("events.show.filterModal.endLabel")}
        </MDTypography>
        <MDDatePicker
          input={{ placeholder: t("events.show.filterModal.placeholderDatetime") }}
          value={
            updateEvent.valid_until ? new Date(updateEvent.valid_until) : null
          } // Ensures it's either a Date object or null
          options={{
            enableTime: true,
            dateFormat: "d/m/Y H:i",
            altFormat: "d/m/Y H:i",
            time_24hr: true,
          }}
          onChange={(date) => handleDateChange(date, "valid_until")}
        />
      </Grid>

      {/* Verification */}
      <Grid item xs={12} sm={12} mt={2}>
        <MDTypography
          component="label"
          variant="button"
          fontWeight="regular"
          color="text"
          sx={{ display: "block", width: "100%", mb: 1 }}
        >
          {t("events.show.updateForm.verification")}
        </MDTypography>

        <FormControl fullWidth>
          <Select
            value={updateEvent.verification ?? 0}
            onChange={(e) =>
              setUpdateEvent((prev) => ({
                ...prev,
                verification: Number(e.target.value),
              }))
            }
            displayEmpty
            inputProps={{ "aria-label": "Verification" }}
            sx={{
              "&.MuiInputBase-root": {
                minHeight: 48,
              },
              "& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input": {
                paddingTop: "12px",
                paddingBottom: "12px",
              },
            }}
          >
            <MenuItem value={0}>{t("events.show.updateForm.no")}</MenuItem>
            <MenuItem value={1}>{t("events.show.updateForm.yes")}</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      {/* Action Buttons */}
      <MDBox display="flex" justifyContent="flex-end" mt={3}>
        <MDButton onClick={onCancel} variant="text" color="primary">
          {t("common.buttons.cancel")}
        </MDButton>
        <MDButton
          color="secondary"
          onClick={() => onSubmit(updateEvent)}
          variant="contained"
        >
          {t("common.buttons.save")}
        </MDButton>
      </MDBox>
    </MDBox>
  );
}

export default UpdateForm;
